/**
 * Catalog import endpoints (bos-api API-185).
 *
 * Relative to the axios client's base, which already ends in `/api/v1` — so
 * `/catalog-imports/preview` reaches `…/api/v1/catalog-imports/preview`. See
 * `CONTRACT.md`.
 */

export const CatalogImportsEndpoints = {
    /** POST — what importing the body would do; writes nothing. */
    preview: () => '/catalog-imports/preview',
    /** POST — imports the body in one transaction; 201 with the record. */
    import: () => '/catalog-imports',
    /** GET — a branch's import history, newest first, paginated. */
    list: () => '/catalog-imports',
    /** GET — one import's record. */
    byId: (id: string) => `/catalog-imports/${encodeURIComponent(id)}`,
    /** POST (no body) — undoes the latest import while onboarding is open. OrgAdmin. */
    undo: (id: string) => `/catalog-imports/${encodeURIComponent(id)}/undo`,
};
